import './App.css';
import {Route, Routes} from "react-router-dom";
import Home from "./Pages/Home";
import SelectPage from "./Pages/nb/SelectPage";
import ResultPage from "./Pages/nb/ResultPage";
import GiftPage from "./Pages/nb/GiftPage";
import { ResultNbcPage } from './Pages/nb/ResultNbcPage';

function App() {
    return (
        <div className="App">
            <Routes>
                <Route path={"/nb/*"}>
                    <Route path={""} element={<Home/>}/>
                    <Route path={"selection"} element={<SelectPage/>}/>
                    <Route path={"result"} element={<ResultPage/>}/>
                    <Route path={"resultNbc"} element={<ResultNbcPage/>}/>
                    <Route path={"gift"} element={<GiftPage/>}/>
                </Route>
                <Route path={"/"} element={<Home/>}/>
            </Routes>
        </div>
    );
}

export default App;
